<script lang="ts" setup>
import { classNames } from '@afinius/utilities/class-names';

interface Props {
  minWidth?: string;
  maxWidth?: string;
  hasNoSpacing?: boolean;
  hasFullSpacing?: boolean;
}

withDefaults(defineProps<Props>(), { minWidth: undefined, maxWidth: undefined });
</script>

<template>
  <div
    class="dropdown-body"
    :class="classNames({ hasNoSpacing, hasFullSpacing })"
    :style="{ minWidth, maxWidth }"
  >
    <slot />
  </div>
</template>

<style lang="scss">
@use './DropdownBody.scss';
</style>
